import { render, staticRenderFns } from "./BeiAn.vue?vue&type=template&id=10d9e906"
import script from "./BeiAn.vue?vue&type=script&lang=js"
export * from "./BeiAn.vue?vue&type=script&lang=js"
import style0 from "./BeiAn.vue?vue&type=style&index=0&id=10d9e906&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports